import { validateMobileNumber } from '../../../services/helpers';

export const regionType = [
  { key: 'Region Type 1', val: 'regionType1' },
  { key: 'Region Type 2', val: 'regionType2' }
];

export const userTypes = [
  { key: 'On Demand', val: 'ON_DEMAND' },
  { key: 'Consignee', val: 'CONSIGNEE' },
  { key: 'Consigner', val: 'CONSIGNER' },
  { key: 'Client User', val: 'ZOOM_CLIENT_USER' },
  { key: 'Client User Admin ', val: 'ZOOM_CLIENT_USER_ADMIN' },
  { key: 'SAM', val: 'SAM' },
  { key: 'SAM Lead', val: 'SAM_LEAD' },
  { key: 'Field User', val: 'FIELD_USER' }
];

export const clusterType = [
  { key: 'Cluster Type 1', val: 'clusterType1' },
  { key: 'Cluster Type 2', val: 'clusterType2' }
];

export const ccAdminRoles = userProfile =>
  userProfile.authorities.indexOf('ROLE_EDIT_ZOOM_NOTIFICATIONS_USER') !== -1;

export const validateUserCallData = userData => {
  // Client side validations
  if (!userData) {
    return 'Please enter user data';
  } else if (userData) {
    const { userType } = userData;
    if (!userData.clientId) {
      return 'Please select client';
    }
    if (!userData.name) {
      return 'Please enter user name';
    }
    if (userType !== 'FIELD_USER' && !userData.email) {
      return 'Please enter email';
    }
    if (userType === 'FIELD_USER' && !userData.mobileNumber) {
      return 'Please enter mobile number';
    }
    if (
      userType === 'FIELD_USER' &&
      userData.mobileNumber &&
      !validateMobileNumber(userData.mobileNumber)
    ) {
      return 'Please enter a valid mobile number';
    }
  }
  return null; // null means valid user data
};

export const getUserTypeList = allowedUserTypes => {
  const toReturn = [];
  userTypes.map(usertype => {
    if (allowedUserTypes.indexOf(usertype.val) !== -1) {
      toReturn.push(usertype);
    }
    return usertype; // for eslint
  });
  return toReturn;
};
